module.exports = __webpack_public_path__ + "images/store_case_study/camelion-pic1_7a016e37f455e383b27c49474994e3a3.jpg";